export function getRecurrence(recurrence?: number): string {
  if (recurrence === 3) return "/trimestre";
  if (recurrence === 12) return "/an";
  return "/mois";
}
